const step = {
  route: '/homeowners-insurance/quotes/applicant-info',
  isAccessible: (): boolean => true,
  breadcrumbStep: 'applicants',
};

export default step;
